import { HostBinding, Component, OnInit } from '@angular/core';

import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { DocumentosService } from 'app/shared/documentos/documentos.service';
import { VestibularService } from '../shared/vestibular.service';
import { PdfResuldadosService } from './shared/pdf-resuldados.service';

import { AgrupadorDocumentos } from 'models/documento';
import { Vestibular, Resultado, ResultadoDia } from 'models/vestibular';
import { NotificationsService } from 'angular2-notifications';

import { environment } from 'environments/environment';


@Component({
  selector: 'app-resultados',
  templateUrl: './resultados.component.html',
  styleUrls: ['./resultados.component.scss'],
  animations: [routerTransition],
})
export class ResultadosComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  environment = environment;

  vestibulares: Vestibular[] = null;
  vestibularesCarregando = true;
  gruposDocMedicina: AgrupadorDocumentos[] = [];
  resultadosMedicinaLoading = true;

  confCapitalize = {
    forcar: ['ceuma'],
    forcarCaixaAlta: ['ead', '(ead)'],
  };

  constructor(
    private vestibularService: VestibularService,
    private pdf: PdfResuldadosService,
    private documentosService: DocumentosService,
    private blockSpinner: BlockingSpinnerService,
    private notification: NotificationsService,
  ) { }

  mostrarResultados(vestibular) {
    if (!vestibular.resultados) {
      vestibular.resultados = [];
      vestibular.loadingResultados = true;

      return this.vestibularService.getResultados(vestibular.id.ano, vestibular.id.codigo).then((resultados: Resultado[]) => {
        vestibular.resultados = resultados
          .sort((a, b) => a.getDiaTimestamp() > b.getDiaTimestamp() ? -1 : 1);

        vestibular.loadingResultados = false;
      });
    }
  }

  ngOnInit() {
    this.vestibularService.vestibularesComResultados().then((vestibulares: Vestibular[]) => {
      this.vestibularesCarregando = false;
      this.vestibulares = this.filtrarVestibulares(vestibulares);
    });

    this.getResultadosMedicina();
  }

  gerarPDF(vestibular, resultado) {
    this.blockSpinner.show();

    const date = new Date(resultado.dia);
    const bits = date.toISOString().split('T')[0].split('-');
    const dtProva = `${bits[2]}/${bits[1]}/${bits[0]}`;

    this.vestibularService.getResultadosDia(vestibular.id.ano, vestibular.id.codigo, resultado.dia)
      .then((aprovados: ResultadoDia[]) => {
        this.pdf.gerarPDF({ aprovados: aprovados, dtProva: resultado.dia }, vestibular).subscribe((data)=>{
          this.pdf.handleFile(data,`${vestibular.titulo} ${vestibular.anoSemestre} | ${dtProva}.pdf`);
          this.blockSpinner.close();
        },(error)=>{
          console.log(error);
          this.notification.error('Erro', 'Ocorreu um erro na geração dos resultados.');
          this.blockSpinner.close();
        });
        this.pdf.gerarPDF({ aprovados: aprovados, dtProva: resultado.dia }, vestibular)
      }).then(() => this.blockSpinner.close());
  }

  filtrarVestibulares(vestibulares: Vestibular[]): Vestibular[] {
    return vestibulares.filter((vestibular: Vestibular) => {
      return vestibular.tipoRaw === 'A';
    });
  }

  getResultadosMedicina() {
    return this.documentosService.queryResultadosMedicina()
      .then((data: AgrupadorDocumentos[]) => {
        this.resultadosMedicinaLoading = false;
        this.gruposDocMedicina = data;
      });
  }
}
